import React from "react";
import { SelectPayableTypeContainer } from "../select-payable-type-container";
import { ThemeProvider } from "react-jss";
import { theme } from "constants/Theme";

export interface ISelectPayableTypeView {
  isMobile: boolean;
}
export const SelectPayableTypeView = () => {
  return (
    <ThemeProvider theme={theme}>
      <SelectPayableTypeContainer />
    </ThemeProvider>
  );
};
export default SelectPayableTypeView;
